import classNames from "classnames";
import { animated, useSpring } from "@react-spring/web";

// Hooks
import useTranslate from "../../../hooks/useTranslate";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

import "./styles.sass";

type ProgressbarProps = {
  size?: "m" | "s";
  variation?: "blue" | "gradient";
  width: number;
  type?: "widget";
};

const Progressbar = (props: ProgressbarProps) => {
  const { variation = "blue", width, size = "m", type } = props;
  const t = useTranslate();
  const currentWidth = width.toFixed();
  const { isDesktop } = useBreakpoint();

  const progressbarClass = classNames("Progressbar", {
    [`Progressbar__${size}`]: !!size,
    [`Progressbar__${variation}`]: !!variation,
  });

  const animatedWidth = useSpring({
    width: `${width}%`,
    config: { duration: 200 },
  });
  const valueClass = classNames("Progressbar-header__amount", {
    "Progressbar-header__amount_widget": type === "widget" && !isDesktop,
  });

  return (
    <>
      <div className="Progressbar-header">
        {((type && isDesktop) || !type) && (
          <span className="BonusCardFace-content-progress__title">
            {t("bonus.block.progress")}
          </span>
        )}
        <span className={valueClass}>{currentWidth}%</span>
        {type && <span className="Progressbar-header__info">info</span>}
      </div>
      <div className={progressbarClass}>
        <animated.div
          className="Progressbar__front"
          style={{
            ...animatedWidth,
          }}
        />
      </div>
    </>
  );
};

export default Progressbar;
